import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { LocalizationContext } from '../../../../AppContext';
import Label from '../../../../components/Label';

import localization from './InfoSummarySettings.local';

const TYPE = {
  DROPDOWN: 'DROPDOWN',
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'NUMBER',
};

export default function InfoSummarySettings({ citysettingdefinitions }) {
  const local = localization[useContext(LocalizationContext)];

  return (
    <Paper sx={{ width: '100%', p: 1, pb: 2 }}>
      <Grid container spacing={2}>
        {citysettingdefinitions && citysettingdefinitions
          .filter((item) => item.value)
          .map((definition) => (
            <Grid key={definition.id} container item xs={12}>
              <Grid item xs={12}>
                <Typography variant="h6">{definition.name}</Typography>
              </Grid>
              { definition.type === TYPE.BOOLEAN && (
              <Grid container item xs={12}>
                <Grid item xs={6}>
                  <Label label={local.true} value={definition.value.true} />
                </Grid>
                <Grid item xs={6}>
                  <Label label={local.false} value={definition.value.false} />
                </Grid>
              </Grid>
              )}
              { definition.type === TYPE.NUMBER && (
              <Grid container item xs={12}>
                <Label label={local.numbers} value={definition.value} />
              </Grid>
              )}
              { definition.type === TYPE.DROPDOWN && (
              <Grid container item xs={12}>
                { Object.keys(definition.value).map((key) => (
                  <Grid key={key} item xs={6} md={4}>
                    {console.log({ key, definition })}
                    <Label label={key} value={definition.value[key]} />
                  </Grid>
                ))}
              </Grid>
              )}
            </Grid>
          ))}
      </Grid>
    </Paper>
  );
}

InfoSummarySettings.propTypes = {
  citysettingdefinitions: PropTypes.arrayOf(PropTypes.shape({})),
};

InfoSummarySettings.defaultProps = {
  citysettingdefinitions: undefined,
};
